<template>
  <div class="user-contact">
    <div class="ly-card">
      <el-input
        placeholder="姓名/证件号码"
        style="width: 220px"
        class="m-r-10"
        v-model="searchFormData.query"
        clearable
      ></el-input>
      <el-select class="m-r-10" v-model="searchFormData.reserve_time" placeholder="请选择预约时间" clearable>
        <el-option :key="1" label="5月29日" value="2021-05-29"></el-option>
        <el-option :key="2" label="5月30日" value="2021-05-30"></el-option>
        <el-option :key="3" label="5月31日" value="2021-05-31"></el-option>
        <el-option :key="4" label="6月1日" value="2021-06-01"></el-option>
      </el-select>
      <el-date-picker
        type="datetimerange"
        clearable
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        placeholder="生成时间"
        :default-time="['00:00:00', '23:59:59']"
        value-format="yyyy-MM-dd HH:mm:ss"
        v-model="time"
        @change="changeTime"
      >
      </el-date-picker>
      <el-button class="m-l-10" type="primary" size="medium" @click="search">查询</el-button>
      <!-- <el-button type="primary" size="medium" @click.native="exportExcel">导出</el-button> -->
    </div>
    <div class="content ly-card">
      <ly-table
        :getTableData="getTableData"
        :tableHeader="tableHeader"
        :searchFormData="searchFormData"
        ref="lyTable"
        class="width-full"
      >
      </ly-table>
    </div>
  </div>
</template>
<script>
import { Input, Select, Option, DatePicker } from 'element-ui';
import LyTable from '@/components/LyTable';
import cAppointment from '@/api/cAppointment';
import { appointmentTable } from '@/utils/communityHeader';

export default {
  name: 'RegisterUser',
  components: {
    LyTable,
    ElInput: Input,
    ElSelect: Select,
    ElOption: Option,
    ElDatePicker: DatePicker
  },
  data() {
    return {
      checkTabs: 'base',
      tableHeader: appointmentTable,
      searchFormData: {
        query: '',
        reserve_time: '',
        start_time: '',
        end_time: ''
      },
      time: '',
      getTableData: cAppointment.appointmentList,
      dialogVisible: false,
      baseUrl: '',
      loading: false,
      defaultRsFormItem: {},
      isAddRsUser: false,
      formConfigRs: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 12
      }
    };
  },
  async mounted() {
    this.search();
  },
  methods: {
    search() {
      this.$refs.lyTable.setData();
    },
    changeTime(value) {
      if (value && value.length) {
        [this.searchFormData.start_time, this.searchFormData.end_time] = value;
      } else {
        [this.searchFormData.start_time, this.searchFormData.end_time] = ['', ''];
      }
    }
  }
};
</script>
<style>
.user-contact .el-image__preview {
  height: 25px;
  width: auto;
}
.register-contact-form .el-input {
  width: 212px;
}
</style>
